import type {
  CandidateResumeAppliedFilters,
  CandidateResumeFilterFormValues,
} from './types';

export const DEFAULT_RESUME_FILTER_FORM_VALUES: CandidateResumeFilterFormValues =
  {
    desiredJob: '',
    employmentTypeId: null,
    scheduleWorkId: null,
    isActive: null,
  };

export const DEFAULT_RESUME_APPLIED_FILTERS: CandidateResumeAppliedFilters = {
  desiredJob: '',
  employmentTypeId: null,
  scheduleWorkId: null,
  isActive: null,
};

export const DEFAULT_RESUME_PAGE = 1;
export const DEFAULT_RESUME_PAGE_SIZE = 15;
